"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationTokenExpireIn = void 0;
class ApplicationTokenExpireIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ApplicationTokenExpireIn.attributeTypeMap;
    }
}
exports.ApplicationTokenExpireIn = ApplicationTokenExpireIn;
ApplicationTokenExpireIn.discriminator = undefined;
ApplicationTokenExpireIn.attributeTypeMap = [
    {
        "name": "expiry",
        "baseName": "expiry",
        "type": "number",
        "format": "int64"
    }
];
//# sourceMappingURL=ApplicationTokenExpireIn.js.map